import React, { useEffect, useState } from 'react';
import LandingPageView from './LandingPageView';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import CustomAlert from '../../components/CustomAlert';
import { useTranslation } from 'react-i18next';
import CustomLoading from '../../components/CustomLoading';
import Geocode from 'react-geocode';
import { configuration } from '../../config/main.config';
import { getAddressHome, getAppConfig, setAddressHome, setPackageInfo, setPackageSeleted, setUTMInfo } from '../../utils/commons';
import { capitalize, sortByPrice } from '../../utils/util';

export default function LandingPageController(props) {
    const { t } = useTranslation();

    const [showLoading, setShowLoading] = useState(false);
    const [packages, setPackages] = useState([]);
    const [address, setAddress] = useState(null);
    const [message, setMessage] = useState({});
    const [choosePackage, setChoosePackage] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showTerm, onShowTerm] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [addressInfor, setAddressInfor] = useState(null);
    const [showListAddresses, setShowListAddresses] = useState(false);
    const [addressSelected, setAddressSelected] = useState(null);
    const [searchType, setSearchType] = useState(0);
    const [ispLocation, setISPLocation] = useState(null);

    useEffect(() => {
        onLoadData();
    }, []);

    const onLoadData = async () => {
        setShowLoading(true);
        var url = new URL(window.location.href);
        console.log("url===", url);
        var utm_source = url.searchParams.get("utm_source");
        var utm_campain = url.searchParams.get("utm_campaign");
        if(utm_source && utm_campain){
            setUTMInfo({
                utm_source: utm_source,
                utm_campain: utm_campain,
            })
        }
        await onLoadProducts();
        setShowLoading(false);
    }

    const onLoadProducts = async () => {
        try {
            var result = await wsclients.lab4services.getProductsV2();
            console.log("result getProducts===", result);
            if (result.code == 'OK') {
                setPackages(result.data ? result.data : []);
            }
        }
        catch (ex) {
            console.log("getProducts exception: ", ex);
        }
    }

    const onSelectPackage = async (product) => {
        let packageSelected = {
            ...product,
        };
        if(product && product.product_type === 'vuma_core'){
            packageSelected.name = product.product && product.product.name ? product.product.name : null;
            packageSelected.id = product.product && product.product.id ? product.product.id : null;
            packageSelected.sku = product.product && product.product.sku ? product.product.sku : null;
        }

        setPackageSeleted(packageSelected);
        props.history.push(paths.package_info);
    }

    const onCheckCoverage = async () => {
        setShowLoading(true);
        let address_info = {};
        try {
            console.log("address===", address);
            if (address && address.description) {
                await Geocode.setApiKey(configuration.apiKeyMap);
                var resultAddress = await Geocode.fromAddress(address.description);
                console.log("resultAddress==", resultAddress);
                if (resultAddress.status == 'OK') {
                    if (resultAddress && resultAddress.results.length > 0) {
                        let location = resultAddress.results[0].geometry && resultAddress.results[0].geometry.location ? resultAddress.results[0].geometry.location : null;
                        address_info.latitude = location.lat ? location.lat : null;
                        address_info.longitude = location.lng ? location.lng : null;

                        if (resultAddress.results[0].address_components && resultAddress.results[0].address_components.length > 0) {
                            //city: locality, administrative_area_level_1: state/province, country: country, street_name: route
                            resultAddress.results[0].address_components.forEach(element => {
                                if (element.types.length > 0) {
                                    if (element.types[0] === 'postal_code') {
                                        address_info.postal_code = element.long_name;
                                    } else if (element.types[0] === 'street_number') {
                                        address_info.street_number = element.long_name;
                                    } else if (element.types[0] === 'route') {
                                        address_info.street_name = element.long_name;
                                    } else if (element.types[0] === 'administrative_area_level_1') {
                                        address_info.state_province_county = element.long_name;
                                    } else if((address_info.state_province_county == null || address_info.state_province_county == "") && element.types[0] === 'locality'){
                                        address_info.state_province_county = element.long_name;
                                    }
                                }
                            });
                        }
                    }
                    // address_info.town_city = address_info.state_province_county;
                    console.log("address_info==", address_info);
                    setAddressInfor(address_info);
                    var result = await wsclients.lab4services.onCheckCoverageV2(address_info);
                    console.log("onCheckCoverrage===", result);
                    if (result.code === 'OK') {
                        setAddresses(result.data.addresses ? result.data.addresses : []);
                        if (result.data.addresses && result.data.addresses.length === 1) {
                            // setShowModal(true);
                            setAddressSelected(result.data.addresses[0]);
                            setAddressHome({
                                ...result.data.addresses[0],
                                ...address_info,
                            });
                            let locationAvaible = await checkLocationAvaibleOrder();
                            if(locationAvaible){
                                setShowModal(true);
                            }
                        } else if (result.data.addresses && result.data.addresses.length > 1) {
                            setShowListAddresses(true);
                        } else {
                            setMessage({
                                show: true,
                                content: t('address_not_support')
                            });
                        }
                    }
                }
            }
        }
        catch (ex) {
            console.log("onCheckCoverrage exception===", ex);
        }
        setShowLoading(false);
    }

    const onCheckCoverageISPLocation = async () => {
        setShowLoading(true);
        let address_info = {
            location_reference: ispLocation,
        };
        try {
            var result = await wsclients.lab4services.onCheckCoverageV2(address_info);
            console.log("onCheckCoverrage===", result);
            if (result.code === 'OK') {
                setAddresses(result.data.addresses ? result.data.addresses : []);
                if(result.data.location){
                    address_info = {
                        ...address_info,
                        ...result.data.location,
                        street_name: result.data.location && result.data.location.street_name ? capitalize(result.data.location.street_name) : null,
                    }
                }
                console.log('address_info AAAAA===', address_info)
                if (result.data.addresses && result.data.addresses.length === 1) {
                    // setShowModal(true);
                    setAddressSelected(result.data.addresses[0]);
                    setAddressHome({
                        ...result.data.addresses[0],
                        ...address_info,
                    });
                    let locationAvaible = await checkLocationAvaibleOrder();
                    if(locationAvaible){
                        setShowModal(true);
                    }
                } else if (result.data.addresses && result.data.addresses.length > 1) {
                    setShowListAddresses(true);
                } else {
                    setMessage({
                        show: true,
                        content: t('address_not_support')
                    });
                }
            }
        }
        catch (ex) {
            console.log("onCheckCoverrage exception===", ex);
        }
        setShowLoading(false);
    }

    const onSetAddressSelected = async (address) => {
        if (address) {
            setAddressSelected(address);
            setAddressHome({
                ...address,
                ...addressInfor,
            });
            setShowListAddresses(false);
            let locationAvaible = await checkLocationAvaibleOrder();
            if(locationAvaible){
                setShowModal(true);
            }
            setShowLoading(false);
        }
    }

    const onProcessCheckCoverage = async (type) => {
        console.log("ispLocation===", ispLocation);
        if (type === 0) {
            await onCheckCoverage();
        } else {
            await onCheckCoverageISPLocation();
        }
    }

    const checkLocationAvaibleOrder = async () => {
        setShowLoading(true)
        try{
            let addressSelected = getAddressHome();
            if(addressSelected){
                let result = await wsclients.lab4services.checkLocationAvaibleOrder(addressSelected.premise_ref_isp);
                setShowLoading(false)
                console.log("checkLocationAvaibleOrder result: ", result);
                if(result.code === 'OK'){
                    if(result.data && result.data.is_available_create_order){
                        return true;
                    } else {
                        setMessage({
                            show: true,
                            content: result.data && result.data.descriptions ? result.data.descriptions : t('address_used')
                        });
                    }
                }
            }
        }catch(ex){
            console.log("checkLocationAvaibleOrder exception: ", ex);
        }   
    }

    const { classes, language } = props;
    console.log("addressSelected===", addressSelected);

    return (
        <>
            <LandingPageView
                language={language}
                classes={classes}
                packages={packages}
                address={address}
                choosePackage={choosePackage}
                showModal={showModal}
                showTerm={showTerm}
                showListAddresses={showListAddresses}
                addresses={addresses}
                addressSelected={addressSelected}
                searchType={searchType}
                ispLocation={ispLocation}
                onSelectPackage={onSelectPackage}
                onCheckCoverage={onProcessCheckCoverage}
                setAddress={setAddress}
                setChoosePackage={setChoosePackage}
                setShowModal={setShowModal}
                onShowTerm={onShowTerm}
                setAddressSelected={onSetAddressSelected}
                setShowListAddresses={setShowListAddresses}
                setSearchType={setSearchType}
                setISPLocation={setISPLocation}
            />
            {showLoading && <CustomLoading
                open={showLoading}
                handleClose={() => setShowLoading(false)}
            />}
            {message && message.show && <CustomAlert
                open={message.show}
                title={message.title ? message.title : null}
                message={message.content ? message.content : null}
                isConfirm={message.isConfirm ? message.isConfirm : false}
                customMessage={message.customMessage ? message.customMessage : null}
                showButtonClose={true}
                onClose={() => setMessage({})}
                confirmAction={message.confirmAction ? message.confirmAction : null}
            />}
        </>
    )
}
